
const mixin = {
    data: ()=>{
        return {
            lightbox: {
                imgs: '',  // Img Url , string or Array
                visible: false,
                index: 0   // default: 0
            }
        }
    },
    methods:{
        showLightbox(images, index){
            this.lightbox.imgs = images
            this.lightbox.index = index
            this.lightbox.visible = true
        },
        closeLightbox(){
            this.lightbox.imgs = ''
            this.lightbox.index = 0
            this.lightbox.visible = false
        },
        changeLightboxImage(e){
            if(!this.lightbox.visible)
                return true
            if(e.keyCode==37) {
                this.shiftLightboxImage(-1)
            }else if(e.keyCode==39) {
                this.shiftLightboxImage(1)
            }
            return true
        },
        shiftLightboxImage(shift){
            let lbi = this.lightbox.index
            lbi = lbi + shift
            if(lbi < 0)
                lbi = 0
            if(lbi >= this.lightbox.imgs.length)
                lbi = this.lightbox.imgs.length-1
            this.lightbox.index = lbi
        },
        rotateLightBoxImage(deg){
            let self = this
            let data = {
                img: self.$root.lightbox.imgs[self.$root.lightbox.index],
                deg: deg
            }
            self.$root.ui.loading.push('rotateImage')
            //let imgs = self.$root.lightbox.imgs
            //imgs[self.$root.lightbox.index] = ''
            //self.$root.lightbox.imgs = []
            let idx = self.$root.lightbox.index
            let imgs = self.$root.lightbox.imgs
            self.$root.lightbox.imgs = JSON.parse(JSON.stringify(imgs))
            self.$root.lightbox.imgs[idx] = undefined
            imgs[idx] = undefined
            //self.$root.lightbox.imgs = imgs
            return self.$store.dispatch('rotateImage', data).then(function (img) {
                return self.clearCache(img).then(function(){
                    self.$root.ui.stopLoading('rotateImage')
                    //imgs[self.$root.lightbox.index] = img
                    //self.$root.lightbox.imgs = imgs
                    self.$root.lightbox.imgs[idx] = img
                    imgs[idx] = img
                    self.$root.lightbox.imgs = imgs
                })
            })
        },
        clearCache(url){
            var headers = new Headers()
            headers.append('pragma', 'no-cache')
            headers.append('cache-control', 'no-cache')

            var init = {
                method: 'GET',
                headers: headers,
                mode: 'no-cors',
                cache: 'no-cache',
            }

            return fetch(new Request(url), init)
        }
    },
    mounted(){
        window.addEventListener("keydown", this.changeLightboxImage)
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/lightbox.js